/**
 * @author: Ashay Tiwari
 * @date: 9 July 2021
 * @description: File for Landing Page
 * @developedBy: Kritin Digital Solutions Pvt. Ltd.
 */

import React, { Suspense, useEffect, useState } from "react";
import { getSessionStorage } from "../../../middlewares/globalFunction";
import { Redirect, useHistory } from "react-router-dom";
import "../../../i18n/i18n";
import Logo from "../../../component/HipozLandingPages/LandingPage/Logo/Logo";
import { TERMS_CONTENT } from "../../../redux/constants/action-types/common.actionTypes";
import { useDispatch, useSelector } from "react-redux";
import { useQuery } from "react-query";
import { getApi } from "../../../middlewares/apiHandler";
import { setTermsData } from "../../../redux/actions/common.actions";
import Loader from "../../../component/UI/Loader/Loader";
import globalStyles from "../../../App.css";
import { Navbar } from "react-bootstrap";
import styles from "./Impressum.css";
import CloseIcon from "@material-ui/icons/Close";
import { useTranslation } from "react-i18next";
import { Document, Page } from 'react-pdf';
// import agreement from '../../../assets/datenschutzrichtlinie_hipoz.pdf'


const Impressum = (props) => {
  const [getTermsQuery, setGetTermsQuery] = useState("");
  const [isApiFetch, setIsApiFetch] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();

  const getTerms = useQuery(
    ["getTerms", getTermsQuery],
    () => getApi(getTermsQuery),
    { enabled: isApiFetch }
  );

  const [fixed, setFixed] = useState(false)

  const terms = useSelector(
    (state) => state.common.terms
  );

  useEffect(()=>{
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  })

  useEffect(() => {
    setGetTermsQuery(`getTerms`);
    setIsApiFetch(true);
  }, [setGetTermsQuery]);

  useEffect(() => {
    if (getTerms.data && getTerms.data.statuscode === 200) {
      dispatch(
        setTermsData(TERMS_CONTENT, getTerms.data.data)
      );
    }
    return () => {
      dispatch(setTermsData(TERMS_CONTENT, ""));
    };
  }, [dispatch, getTerms]);

  const handleScroll = () => {
    if (window.pageYOffset > 140) {
      setFixed(true)
    }else{
      setFixed(false)
    }
  }

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  }

  function createMarkup() { return {__html: terms && terms[0].terms}; };

  return (
    <div className={styles.bgimage}>
      {/* <Helmet title={LoginTitle} /> */}
      {isLoading ? (
        <div className={globalStyles.loaderWrapper}>
          <Loader />
        </div>
      ) : (
        <React.Fragment>
          <div className={"container p-0"}>
            <div className={`row ${styles.contant}`}>
              <div className={"col-md-12 p-0"}>
                <div className={styles.mainForm}>
                  <div className={styles.iconandhead}>
                    <h3 className={styles.signtext}>Impressum und Offenlegung</h3>
                    <CloseIcon
                      className={styles.closeIcon}
                      onClick={() => history.push("/")}
                    />
                  </div>
                  <div className={styles.label}>
                    POPULÄR Werbeagentur GmbH
                  </div>
                  <div className={styles.label}>
                    Franz-Josefs-Kai 39/27
                  </div>
                  <div className={styles.label}>
                    1010 Wien 
                  </div>
                  <div className={styles.label}>
                    eMail: agentur@populaer.at
                  </div>
                  <div className={styles.label}>
                    Tel: +43 1 94 18 19 80
                  </div>
                  <div style={{ marginTop: 10 }}></div>
                  <div className={styles.label}>
                    Geschäftsführer: Bernd Waginger
                  </div>
                  <div className={styles.label}>
                    Firmenbuchnummer:
                  </div>
                  <div className={styles.label}>
                    420955b
                  </div>
                  <div className={styles.label}>
                    UID-Nummer: ATU68932239
                  </div>
                  <div className={styles.label}>
                    Firmengericht:
                  </div>
                  <div className={styles.label}>
                    Handelsgericht Wien
                  </div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      )}
    </div>
  );
};

export default Impressum;
